import React from "react";
import { useLocation } from "react-router-dom";

type MainContentAreaProps = {
  pinned?: boolean;
  children: React.ReactNode;
};

const MainContentArea: React.FC<MainContentAreaProps> = ({
  children,
  pinned,
}) => {
  let sidebarWidth = pinned === undefined ? "ml-0" : pinned ? "ml-64" : "ml-14";
  if (useLocation().pathname.startsWith("/decks")) {
    sidebarWidth = "ml-0"; // Hide sidebar on deck builder routes
  }
  return (
    <main
      className={`flex-grow overflow-y-scroll transition-[margin] duration-300 bg-gray-100 dark:bg-black ${sidebarWidth}`}
    >
      {children}
    </main>
  );
};

export default MainContentArea;
